module.exports = __webpack_public_path__ + "img/pick4.e8e2edf6.png";